
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { doDownload } from "@/utils/oss-download";
import { getSuppliersList } from "@/api/inquiry"
import {listProductName} from "@/api/product-business";
import {create, update} from "@/api/shell-package";

@Component({
  name: "file-management",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "" }) private operate: string;
  @Prop({ default: [] }) private details: any[];
  @Prop({ default: "" }) private shellPackageInfoId: string;
  @Prop({ default: "" }) private customerId: string;
  @Prop({ default: "" }) private brandId: string;

  public info = {} as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "SN",
      prop: "sn",
      key: "sn",
      show: true,
      disabled: false,
      type: "input",
      width: "20",
    },
    {
      label: "表头",
      prop: "description",
      key: "description",
      show: true,
      disabled: false,
      type: "input",
      width: "50",
    },
    {
      label: "内容",
      prop: "value",
      key: "value",
      show: true,
      disabled: false,
      type: "textarea",
      rows: 1,
    },
  ] as any;

  private formList = [
    {
      label: "选择品名",
      prop: "productId",
      key: "productId",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getProductList,
      remote: true,
      clearable: true,
      options: [],
      labelKey: "name",
      valueKey: "id",
      rules: [
        {
          required: true,
          message: "请选择品名",
          trigger: "change",
        },
      ],
    },
    {
      label: "添加供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "通用供应商",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      labelKey: "abbreviation",
      valueKey: "id",
    },
  ] as any;

  private form = {
    supplierId: null,
    supplierAbbr: null,
    productId: null,
    productName: null
  };

  @Watch("details", {immediate: true})
  private watchTableList() {
    const list = [] as any[];
    for (let i = 0; i < 12; i++) {
      const value = this.details.filter(item => item.sn === String(i+1))[0];
      if (value !== undefined) {
        list.push(value);
      }else {
        list.push({sn: String(i+1), description: "", value: ""});
      }
    }
    this.table.list = list;
  }

  private open() {
    if (this.operate === "新增") {
      this.tableCol[1].readonly = false;
      this.tableCol[2].readonly = false;
      this.formList[0].disabled = false;
      this.formList[1].disabled = false;
    }
    if (this.operate === "详情") {
      this.tableCol[1].readonly = true;
      this.tableCol[2].readonly = true;
      this.formList[0].disabled = true;
      this.formList[1].disabled = true;
    }
    if (this.operate === "编辑") {
      this.tableCol[1].readonly = false;
      this.tableCol[2].readonly = false;
      this.formList[0].disabled = true;
      this.formList[1].disabled = true;
    }
  }

  private close() {
  this.form = {
      supplierId: null,
      supplierAbbr: null,
      productId: null,
      productName: null
    };
    this.$emit("update:show", false);
  }

  private async getProductList(name) {
    this.formList[0].options = await listProductName({keyword: name}) as any;
  }

  private async getSuppliersList(name = "") {
    this.formList[1].options = await getSuppliersList({ abbreviation: name }) as any;
  }

  private handleDownload(scope: any) {
    console.log(scope.row);
    doDownload(scope.row.ossUrl);
  }

  private submitForm() {
    try {
      if (this.operate === "新增") {
        this.addShellPackageInfo();
      }
      if (this.operate === "编辑") {
        this.editShellPackageInfo();
      }
    } catch (error) {
      console.error(error);
    }
  }

  private async addShellPackageInfo() {
    try {
      const data = {
        customerId: this.customerId,
        brandId: this.brandId,
        productId: this.form.productId,
        supplierId: this.form.supplierId === null ? "通用供应商" : this.form.supplierId,
        shellPackageDetailReqs: this.table.list
      }
      await create(data);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }

  private async editShellPackageInfo() {
    try {
      const data = {
        shellPackageInfoId: this.shellPackageInfoId,
        shellPackageDetailReqs: this.table.list
      };
      await update(data);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }

  private changeUpdateOther() {
    if (this.form.supplierId === null || this.form.supplierId === "") {
      this.form.supplierId = "通用供应商";
    }
  }
}
